import React from 'react';

export const Branding: React.FC = () => {
  return (
    <div className="ha-text-center ha-py-4 ha-border-t ha-border-border\\/50 ha-mt-4">
      <a
        href="https://rate-match.com"
        target="_blank"
        rel="noopener noreferrer"
        className="ha-text-xs ha-text-muted-foreground hover:ha-text-primary ha-transition-colors"
        style={{ textDecoration: 'none' }}
      >
        ⚡ Powered by <span className="ha-font-semibold">Rate-Match</span> | Direct Booking Expert
      </a>
    </div>
  );
};
